export function removeUnknownString(strContainUnknownSpace: string): string {
  // FIXED case 1 of https://effily.atlassian.net/browse/XSELLY-725
  // สับ Unknown character ที่แม่ค้า copy ติด clipboard มา ออกไป
  return strContainUnknownSpace.replace(/​/g, '')
}
